import { useEffect, useState } from "react";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { resetSession } from "../../redux/auth";
import {
  deleteSingleSopDetailsAction,
  getSopModuleListAction,
  hideUnhideSopAction,
  resetSopModuleError,
  resetSopModuleListTotal,
  resetSopModuleListing,
  resetSopModuleMessage,
  resetSopModuleStatusCode,
  resetSopModuleSuccess,
} from "../../redux/sopModule";
import {
  DeleteSingleSopDetailsPayloadType,
  GetSopModulePayloadType,
  HideSopPayloadType,
} from "../../commonTypes/sopModuleTypes";
import { EmptyList } from "../../assets/images";
import SopModuleTable from "../../components/SopModule/SopModuleTable/SopModuleTable";
import { SOP_MODULE_HEADERS } from "../../constant/tableHeadersConstants/sopModuleHeaderConst";
import { SearchIcon } from "../../components/Icon";
import useDebounce from "../../customHooks/useDebounce";
import { useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { LoginResponseType } from "../../redux/auth/authTypes";

type AppProps = {
  history: any;
  fetching: boolean;
  message: string | null;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  sopModuleTotalCount: number;
  sopModuleList: any;
  dispatchResetSession: () => void;
  dispatchResetSopModuleError: () => void;
  dispatchResetSopModuleSuccess: () => void;
  dispatchResetSopModuleStatusCode: () => void;
  dispatchResetSopModuleListing: () => void;
  dispatchResetSopModuleMessage: () => void;
  dispatchGetSopModuleListAction: (data: GetSopModulePayloadType) => void;
  dispatchDeleteSingleSopDetailsAction: (
    data: DeleteSingleSopDetailsPayloadType
  ) => void;
  dispatchResetSopCount: () => void;
  dispatchHideUnhideSopAction:(data:HideSopPayloadType)=>void;
  loginData: LoginResponseType;

};

const SopModule = ({
  history,
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  loginData,
  sopModuleList,
  sopModuleTotalCount,
  dispatchResetSession,
  dispatchResetSopModuleError,
  dispatchResetSopModuleSuccess,
  dispatchResetSopModuleStatusCode,
  dispatchResetSopModuleListing,
  dispatchResetSopModuleMessage,
  dispatchGetSopModuleListAction,
  dispatchDeleteSingleSopDetailsAction,
  dispatchResetSopCount,
  dispatchHideUnhideSopAction
}: AppProps) => {
  const { id }: any = useParams();
  const clientCode = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : id;
  const company_name = history?.location?.state?.company_name;
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [finalListingData, setFinalListingData] = useState<any>([]);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState<boolean>(false);
  const [deleteId, setDeleteId] = useState("");

  //===============================User Management============================
  const [isSOPAddPresent, setIsSOPAddPresent] = useMenuCheck();
  const [isSOPEditPresent, setIsSOPEditPresentt] = useMenuCheck();
  const [isSOPDeletePresent, setIsSOPDeletePresent] = useMenuCheck();
  const [hideSOPPresent , setHideSOPPresent] = useMenuCheck();
  //=============================================================================
  useEffect(() => {
    dispatchResetSopModuleListing();
    dispatchResetSopModuleStatusCode();
    dispatchResetSopModuleMessage();
    dispatchResetSopModuleError();
    dispatchResetSopModuleSuccess();
    dispatchResetSopCount();
    window.scroll({
      top: 0,
      left: 0,
    });
    setIsSOPAddPresent("Add SOP Module", "menu");
    setIsSOPEditPresentt("Edit SOP Module", "menu");
    setIsSOPDeletePresent("Delete SOP", "menu");
    setHideSOPPresent("Hide SOP","menu")
  }, []);

  useEffect(() => {
    dispatchResetSopModuleMessage();
    dispatchResetSopModuleError();
    dispatchResetSopModuleSuccess();

    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        clientCode: clientCode,
        searchValue,
        type:"sop",
        userType:loginData?.user_type
      };
      if (sopModuleTotalCount) {
        if (offset < +sopModuleTotalCount) {
          dispatchGetSopModuleListAction(finalData);
        }
      } else {
        dispatchGetSopModuleListAction(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (sopModuleList?.length === 0) {
      setFinalListingData(sopModuleList);
    } else if (offset > 0 && sopModuleList?.length > 0) {
      setFinalListingData((prv: any) => [...prv, ...sopModuleList]);
    } else {
      setFinalListingData(sopModuleList);
    }
  }, [sopModuleList]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < sopModuleTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (sopModuleList?.length > 0) {
          if (!fetching && offset < sopModuleTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (message?.includes("has been deleted successfully!")) {
      toast.success("SOP has been deleted successfully!", {
        duration: 2000,
      });
    }
   else if (message==="Standard Operating Procedure has been hidden successfully!") {
      toast.success("Standard Operating Procedure Hide Successfully!", {
        duration: 2000,
      });
    }
    else if (message==="Standard Operating Procedure has been unhidden successfully!") {
      toast.success("Standard Operating Procedure Unhide Successfully!", {
        duration: 2000,
      });
    }
  }, [message]);


  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [sopModuleList]);

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      }
    },
    500,
    [searchValue]
  );

  const fetchNewData = () => {
    const finalData = {
      token,
      offset,
      limit,
      clientCode: clientCode,
      searchValue,
      type:"sop",
      userType:loginData?.user_type

    };
    if (token) {
      if (offset === 0) {
        dispatchGetSopModuleListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchValue(value);
    if (value?.length === 0) {
      const finalData = {
        token,
        offset,
        limit,
        clientCode: clientCode,
        type:"sop",
        userType:loginData?.user_type

      };
      if (token) {
        if (offset === 0) {
          dispatchGetSopModuleListAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
  };

  const handleHideSop=(data:any)=>{
    let finalData={
      token,
      client_code:data?.client_code,
      sop_id:data?.sop_id,
      to_hide:'1'
    }
    dispatchHideUnhideSopAction(finalData)
  }
  const handleUnHideSop=(data:any)=>{
    let finalData={
      token,
      client_code:data?.client_code,
      sop_id:data?.sop_id,
      to_hide:'0'
    }
    dispatchHideUnhideSopAction(finalData)
    

  }


  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSopModuleError();
            }}
          />
        );
      }
    }
    if (success === 1 && message?.includes("has been deleted successfully!")) {
      dispatchResetSopModuleSuccess();
      dispatchResetSopModuleListing();
      dispatchResetSopModuleMessage();

      window.scroll({
        top: 0,
        left: 0,
      });
      const finalData = {
        token,
        offset,
        limit,
        clientCode: clientCode,
        searchValue,
        type:"sop",
        userType:loginData?.user_type

      };
      if (token) {
        if (offset === 0) {
          dispatchGetSopModuleListAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
    if (success === 1 && message?.includes("Standard Operating Procedure has been hidden successfully!")) {
      dispatchResetSopModuleSuccess();
      dispatchResetSopModuleListing();
      dispatchResetSopModuleMessage();

      window.scroll({
        top: 0,
        left: 0,
      });
      const finalData = {
        token,
        offset,
        limit,
        clientCode: clientCode,
        searchValue,
        type:"sop",
        userType:loginData?.user_type

      };
      if (token) {
        if (offset === 0) {
          dispatchGetSopModuleListAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
    if (success === 1 && message==="Standard Operating Procedure has been unhidden successfully!") {
      dispatchResetSopModuleSuccess();
      dispatchResetSopModuleListing();
      dispatchResetSopModuleMessage();

      window.scroll({
        top: 0,
        left: 0,
      });
      const finalData = {
        token,
        offset,
        limit,
        clientCode: clientCode,
        searchValue,
        type:"sop",
        userType:loginData?.user_type

      };
      if (token) {
        if (offset === 0) {
          dispatchGetSopModuleListAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
    return false;
  };

  const handleDelete = (id: any) => {
    setDeleteId(id);
    setSearchValue("");
    setShowDeleteConfirmationModal(true);
  };

  const handleDeleteConfirmationModal = () => {
    setShowDeleteConfirmationModal(!showDeleteConfirmationModal);
  };

  const DeleteSPO = (deleteId: string) => {
    setOffset(0);
    if (token && deleteId) {
      const finalData = {
        token,
        sopId: deleteId,
        clientCode,
      };
      dispatchDeleteSingleSopDetailsAction(finalData);
    }
  };
  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader
          title="SOPs"
          company_name={company_name}
          client_code={clientCode}
        />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">SOPs List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  sopModuleTotalCount ? sopModuleTotalCount : 0
                } SOPs list found`}</div>
              )}
            </div>
            <div className="right-header">
              <div className="col-md-8 position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>
              {isSOPAddPresent && (
                <button
                  onClick={() =>
                    history?.push({
                      pathname: `/sops/${clientCode}/add`,
                      state: { clientCode, company_name },
                    })
                  }
                  className="btn btn-primary"
                >
                  + Add SOP
                </button>
              )}
            </div>
          </div>
          <div>
            {fetching && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : sopModuleList?.length > 0 ? (
              <SopModuleTable
                data={finalListingData}
                fetching={fetching}
                type="sop"
                tableHeaders={SOP_MODULE_HEADERS}
                history={history}
                offset={offset}
                handleDelete={handleDelete}
                isSOPEditPresent={isSOPEditPresent}
                isSOPDeletePresent={isSOPDeletePresent}
                handleHideSop={handleHideSop}
                handleUnHideSop={handleUnHideSop}
                hideSOPPresent={hideSOPPresent}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && sopModuleList?.length === 0 && (
                  <EmptyListPage
                    title="No SOPs List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {showDeleteConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleDeleteConfirmationModal();
          }}
          isOpen={showDeleteConfirmationModal}
          title={`Delete SOP?`}
          message={`Are you sure you want to Delete?`}
          confirmButtonText="Delete"
          onPressConfirm={() => {
            DeleteSPO(deleteId);
            handleDeleteConfirmationModal();
          }}
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.sopModule.success,
  fetching: state.sopModule.fetching,
  message: state.sopModule.message,
  statusCode: state.sopModule.statusCode,
  error: state.sopModule.error,
  sopModuleList: state.sopModule.sopModuleList,
  sopModuleTotalCount: state.sopModule.sopModuleTotalCount,
  loginData: state.auth.loginData,

});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSopModuleSuccess: () => dispatch(resetSopModuleSuccess()),
  dispatchResetSopModuleError: () => dispatch(resetSopModuleError()),
  dispatchResetSopModuleMessage: () => dispatch(resetSopModuleMessage()),
  dispatchResetSopModuleStatusCode: () => dispatch(resetSopModuleStatusCode()),
  dispatchResetSopModuleListing: () => dispatch(resetSopModuleListing()),
  dispatchGetSopModuleListAction: (data: GetSopModulePayloadType) =>
    dispatch(getSopModuleListAction(data)),
  dispatchDeleteSingleSopDetailsAction: (
    data: DeleteSingleSopDetailsPayloadType
  ) => dispatch(deleteSingleSopDetailsAction(data)),
  dispatchResetSopCount: () => dispatch(resetSopModuleListTotal()),
  dispatchHideUnhideSopAction:(data:HideSopPayloadType)=> dispatch(hideUnhideSopAction(data))

});
export default connect(mapStateToProps, mapDispatchToProps)(SopModule);
